import { User } from 'shared/interfaces';

export const localStorageUserTokenKey = 'ps_userToken';
export const localStorageUserInfoKey = 'ps_userInfo';

const userStorage = {
  setToken(token: string) {
    localStorage.setItem(localStorageUserTokenKey, token);
  },

  getToken() {
    return localStorage.getItem(localStorageUserTokenKey);
  },

  setUser(user: User) {
    localStorage.setItem(localStorageUserInfoKey, JSON.stringify(user));
  },

  getUser(): User | null {
    const userInfo = localStorage.getItem(localStorageUserInfoKey);
    return JSON.parse(userInfo as string);
  },

  removeUserAndToken() {
    localStorage.removeItem(localStorageUserInfoKey);
    localStorage.removeItem(localStorageUserTokenKey);
  },

  setSetting(settingContent: any, settingKey: string) {
    localStorage.setItem(settingKey, settingContent.json.value);
  },

  getSetting(settingKey: string) {
    return localStorage.getItem(settingKey);
  },

  removeSetting(settingKey: string) {
    localStorage.removeItem(settingKey);
  },
};

export default userStorage;
